<template>
  <a-tree v-if="menusArray.length > 0"
          @check="treeCheck"
          @rightClick="(rightMenu == true ? treeRightClick : () => { })"
          :tree-data="menusArray"
          :default-expanded-keys="['0']"
          v-model:checkedKeys="roleSelectKeys"
          :showLine="true"
          :checkStrictly="checkStrictly"
          :checkable="checkbox"
          :field-names="{ key: 'id', title: 'name' }">
    <!-- @select="treeSelect" -->
  </a-tree>
  <a-empty v-else />
  <a-dropdown v-if="rightMenu"
              :visible="menusDropVisible"
              :trigger="['contextmenu']"
              :overlayStyle="rightMenusModal.style">
    <template #overlay>
      <a-menu @mouseleave="rightMenusMouseLeave"
              @click="rightMenusClick">
        <a-menu-item key="1">增加子{{ rightMenusModal.name }}</a-menu-item>
        <a-menu-item v-p="'/authorizations/organizations/:id:PUT'"
                     key="2">编辑</a-menu-item>
        <a-menu-item v-p="'/authorizations/organizations/:id:DELETE'"
                     key="3">删除</a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <a-modal v-if="rightMenu"
           v-model:visible="rightMenusModal.visible"
           :title="rightMenusModal.title"
           :confirm-loading="rightMenusModal.confirmLoad"
           @ok="rightMenusConfirm">
    <a-form v-if="rightMenusModal.key != '3'"
            :model="rightMenusModalFormState"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 24 }">
      <a-form-item label="名称"
                   name="name"
                   :rules="[{ required: true, message: '请输入名称' }]">
        <a-input v-model:value="rightMenusModalFormState.name" />
      </a-form-item>
    </a-form>
    <div v-else>
      确认删除组织:<span style="color:red">{{ rightMenusModal.itemName }}</span>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { CORE_AXIOS, type Http } from '@/core'
import { convertArrayToTree } from '@/utils'
import type { TreeProps } from 'ant-design-vue'
import { container } from 'tsyringe'
import { reactive, ref, watch } from 'vue'
import type { MenuItem } from '../../DeclareType'

const axios = container.resolve<Http>(CORE_AXIOS)
const roleSelectKeys = ref<string[]>([])
const oldRoleSelectKeys = ref<string[]>([])
// const roleSelectKeys: TreeProps['checkedKeys'] = reactive({ checked: [], halfChecked: [] })
const menusArray = reactive<MenuItem[]>([])
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const treeArray = ref<any[]>([])
const menusDropVisible = ref<boolean>(false)
const rightMenusModal = reactive({
  id: '',
  itemName: '',
  name: '',
  visible: false,
  title: '',
  key: '',
  confirmLoad: false,
  style: {}
})
const rightMenusModalFormState = reactive<{
  [key: string]: string | number | boolean
  name: string
}>({
  name: ""
})

const props = defineProps({
  idKey: { type: String, default: "" },
  sourceUrlKey: { type: String, default: "" },
  targetUrlKey: { type: String, default: "" },
  resultKey: { type: String, default: "" },
  checkbox: { type: Boolean, default: true },
  rightMenu: { type: Boolean, default: false },
  checkStrictly: { type: Boolean, default: false }
})

const emit = defineEmits<{
  (e: 'pageFn', value: string): void
}>()

watch(
  props, (state) => {
    if (state.idKey) {
      getRoleAndOperate()
    }
  }
)

const allNode = ref([]) as any
const getRoleAndOperate = () => {
  const { idKey, sourceUrlKey, resultKey } = props
  menusArray.length = 0
  roleSelectKeys.value.length = 0
  axios.get("/v1/api/authorizations/" + resultKey).then((result: any) => {
    const resultData: any[] = result[resultKey]
    allNode.value = resultData
    const { tree } = convertArrayToTree<MenuItem>(resultData)
    menusArray.push(...tree)
    return resultData
  }).then((initMenus: any) => {
    if (idKey) {
      axios.get("/v1/api/authorizations/" + sourceUrlKey + "/" + idKey + "/" + resultKey).then((result: any) => {
        const resultData = result[resultKey] as any[]
        const pickupData: string[] = reactive([])
        resultData.forEach(item => {
          const exitsData = initMenus.find((itm: any) => item.id === itm.id)
          if (exitsData) {
            pickupData.push(item.id)
          }
        })
        return pickupData
      }).then((pickData: any) => {
        roleSelectKeys.value = pickData
        if (roleSelectKeys.value.length != allNode.value.length) {
          roleSelectKeys.value = roleSelectKeys.value.filter(item => item !== "0")
        }
        getItemLength(menusArray)
        // console.log(menusArray, '满选数量', treeCount.value)
        const getDotCount = (str: string) => {
          return (str.match(/\./g) || []).length
        }
        roleSelectKeys.value = [...roleSelectKeys.value].sort((a, b) => {
          return getDotCount(a) - getDotCount(b)
        })
        // console.log(roleSelectKeys.value, allNode.value.length, '接口返回选中的数组(会返回选了的所有父级)')
        for (let i = roleSelectKeys.value.length - 1; i >= 0; i--) {
          const item = roleSelectKeys.value[i]
          const allCount = treeCount.value[item]
          // console.log("当前项:", item, "应有数量:", allCount, 4444)
          if (allCount > 0) {
            const count = roleSelectKeys.value.filter(m =>
              m.substring(0, item.length) === item
            ).length
            // console.log("当前数组中符合条件的数量:", count)
            if (count < allCount && item != 0) {
              // console.log("需要删除的父级:", item)
              roleSelectKeys.value.splice(i, 1)
              // console.log("删除后数组:", roleSelectKeys.value)
            }
          }
        }
        // console.log(roleSelectKeys.value, '去除未满的父级后的选中数组')
        oldRoleSelectKeys.value = roleSelectKeys.value
        treeArray.value.push(initMenus)
        magicFilterTree()
      })
    }


  })
}
const treeCount = ref({}) as any // 全选 父级应该有的所有子集数量
const getItemLength = (data: any) => {
  data.forEach((node: any) => {
    if (node.children && node.children.length > 0) {
      const count = allNode.value.filter((m: any) =>
        m.id.substring(0, node.id.length) === node.id
      ).length
      treeCount.value[node.id] = count
      getItemLength(node.children)
    } else {
      treeCount.value[node.id] = 0
    }
  })
}
//awesome Magic Function!!
const magicFilterTree = () => {
  const { idMap } = convertArrayToTree<MenuItem>(treeArray.value[0])
  roleSelectKeys.value = roleSelectKeys.value.filter(k => {
    const n = idMap[k]
    if (!n) { return }
    return n.children?.every(c => roleSelectKeys.value.indexOf(c.id) !== -1)
  })
}


const treeCheck: TreeProps['onCheck'] = async (checkedKeys, info) => {
  // console.log(checkedKeys, roleSelectKeys.value, info, props.checkbox)
  if (props.checkbox == true) {
    const roleSet = new Set(oldRoleSelectKeys.value)
    const checkedSet = new Set(checkedKeys)
    const extra = checkedKeys.filter(item => !roleSet.has(item)) // checkedKeys多出来的数据
    const missing = oldRoleSelectKeys.value.filter(item => !checkedSet.has(item)) // checkedKeys缺少的数据
    if (extra.length > 0) {
      // console.log(`新增--------- 多了 ${extra.length} 个数据:`, extra)
      await confirmTreeState.post(extra)
    } else if (missing.length > 0) {
      // console.log(`删除--------- 少了 ${missing.length} 个数据:`, missing)
      await confirmTreeState.delete(missing.toString())
    }
    // magicFilterTree()
    oldRoleSelectKeys.value = checkedKeys
  } else {
    emit('pageFn', info.node.id)
  }
  // magicFilterTree()

}

const treeSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
  if (props.checkbox == true) {
    if (!roleSelectKeys.value.find(i => i == info.node.id)) {
      const idKeys: string[] = []
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const addCheckedKeys: any[] = treeArray.value[0].filter((k: any) => {
        return k.id.indexOf(info.node.id) != -1
      })
      addCheckedKeys.forEach(item => {
        idKeys.push(item.id)
        roleSelectKeys.value.push(item.id)
      })
      confirmTreeState.post(idKeys)
    } else {
      let idKeys = ''
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const deleteCheckedKeys: any[] = treeArray.value[0].filter((k: any) => {
        return k.id.indexOf(info.node.id) != -1
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      roleSelectKeys.value = roleSelectKeys.value.filter((c: any) => {

        return c.indexOf(info.node.id) == -1
      })
      deleteCheckedKeys.forEach((item, index) => {
        if (deleteCheckedKeys.values.length == index) {
          idKeys += item.id
        } else {
          idKeys += item.id + ','
        }
      })
      confirmTreeState.delete(idKeys)
    }
    magicFilterTree()
  } else {
    emit('pageFn', info.node.id)
  }
}

//Tree rightClick then Menus
const treeRightClick: TreeProps['onRightClick'] = info => {
  const { resultKey } = props
  const { pageX, pageY } = info.event
  const { id, name } = info.node
  rightMenusModal.style = {
    position: 'absolute',
    maxHeight: 40,
    textAlign: 'center',
    offsetWidth: "0",
    left: `${pageX + 10 - 0}px`,
    top: `${pageY + 4 - 0}px`,
    display: 'flex',
    flexDirection: 'row'
  }

  menusDropVisible.value = true
  rightMenusModal.name = resultKey == 'positions' ? '职位' : "组织"
  rightMenusModal.id = id
  rightMenusModal.itemName = name
}

//Leave Menus in tree
const rightMenusMouseLeave = () => {
  rightMenuUtil.menuHidden()
}

//tree click
const rightMenusClick = (info: { key: string }) => {
  rightMenuUtil.menuHidden()
  rightMenuUtil.menuState(info.key)
  rightMenusModal.visible = true

}

//modal confirm
const rightMenusConfirm = () => {
  const { resultKey } = props
  switch (rightMenusModal.key) {
    case "1": //add
      rightMenusModalFormState.parentId = rightMenusModal.id
      axios.post("/v1/api/authorizations/" + resultKey, rightMenusModalFormState).then(() => {
        rightMenusModal.visible = false
        getRoleAndOperate()
      })
      break
    case "2": //edit
      axios.put("/v1/api/authorizations/" + resultKey + "/" + rightMenusModal.id, rightMenusModalFormState).then(() => {
        rightMenusModal.visible = false
        getRoleAndOperate()
      })
      break
    case "3": //delete
      axios.delete("/v1/api/authorizations/" + resultKey + "/" + rightMenusModal.id).then(() => {
        rightMenusModal.visible = false
        getRoleAndOperate()
      })
      break
  }
}


const confirmTreeState = {
  post: (data: string[]) => {
    const { idKey, sourceUrlKey, resultKey } = props
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    axios.post('/v1/api/authorizations/' + sourceUrlKey + "/" + idKey + "/" + resultKey, { ids: data }).then((result: any) => {
    })
  },
  delete: (data: string) => {
    const { idKey, sourceUrlKey, resultKey } = props
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    axios.delete('/v1/api/authorizations/' + sourceUrlKey + "/" + idKey + "/" + resultKey + "?ids=" + data).then((result: any) => {
    })
  }
}

const rightMenuUtil = {
  menuState: (key: string) => {
    rightMenusModal.key = key
    rightMenusModal.title = key == "1" ? '增加子' + rightMenusModal.name + '' : (key == "2" ? '编辑' + rightMenusModal.name + '' : '删除' + rightMenusModal.name + '')
    rightMenusModalFormState.name = key == "2" ? (rightMenusModal.itemName as string) : ""

  },
  menuHidden: () => {
    rightMenusModal.style = {
      display: 'none'
    }
    menusDropVisible.value = false
  }
}

</script>

<style lang = "less" scoped>
:deep(.ant-empty) {
  height: 65vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column
}
</style>
